import {Module, MutationTree} from "vuex";

export class AuthServerState {
  constructor(authServer: string) {
   this.authServer = authServer;
  }

  public authServer: string;
}

const mutations: MutationTree<AuthServerState> = {
  setNextView(state: AuthServerState, authServer: string): void {
    state.authServer = authServer;
  },
};

export const AuthServerStore: Module<AuthServerState, any> = {
  namespaced: true,
  state: new AuthServerState(process.env.ARTISEE_AUTH_SERVER_URL),
  mutations,
};